// @import_dependencies
import React from 'react'
import { store } from 'app_storage/redux-storage'
// @end

// @import components
import {
  AdminDashboardSidebarComponent,
  StudentDashboardSidebarComponent,
  TeacherDashboardSidebarComponent,
  AccountExecutiveDashboardSidebarComponent,
  CompanyDashboardSidebarComponent
} from 'app_components/modules/campus/sidebarSections'
import { IUserState } from 'app_events/auth/types'
// @end

// @import services
// @end

// @import utilities
// @end

// @import types
interface IAppProps {}
// @end

class AppService {

  private storeObject: any
  private app: any
  private auth: IUserState

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.storeObject = store
    this.app = this.storeObject?.getState().app
    this.auth = this.storeObject?.getState().auth
  }

  public renderSidebar = (props?: IAppProps, history?: any): React.ReactNode => {
    if (this.app && this.app.sidebarComponent) {
      switch (this.app.sidebarComponent.component) {
        case 'admin_dashboard_sidebar':
          return <AdminDashboardSidebarComponent {...props} />
        case 'teacher_dashboard_sidebar':
          return <TeacherDashboardSidebarComponent {...props} />
        case 'account_executive_dashboard_sidebar':
          return <AccountExecutiveDashboardSidebarComponent {...props} />
        case 'company_sidebar':
          return <CompanyDashboardSidebarComponent {...props} />
        default:
          return null
      }
    } else {
      return null
    }
  }

}

export default AppService
